<template>
  <v-row class="justify-end">
    <v-menu bottom min-width="200px" rounded offset-y>
      <template v-slot:activator="{ on }">
        <div>
          <v-btn icon x-large v-on="on" class="mr-2">
            <v-avatar size="40" class="primary4 white--text text-h5">
              {{ avatarItems.initials }}
            </v-avatar>
          </v-btn>
        </div>
      </template>
      <v-card>
        <v-list-item-content class="justify-center">
          <div class="mx-auto">
            <div class="text-center text-capitalize">
              <v-avatar width="85" height="85">
                <v-img :src="getAvatarMenuImage(avatarItems.rol)" transition="scale-transition" height="85" />
              </v-avatar>
              <h3>{{ avatarItems.fullName }}</h3>
            </div>
            <v-divider class="my-3"></v-divider>
            <div v-for="item in avatarItems.items" :key="item.id">
              <v-btn depressed rounded text class="my-3" @click="insertRoute(item.to)">
                <div>
                  <v-icon size="28px">{{ item.icon }}</v-icon>
                </div>
                <div class="ml-2 text-capitalize">
                  {{ item.name }}
                </div>
              </v-btn>
            </div>
            <router-link :to="{ name: 'HomePro' }">
              <div>
                <v-btn depressed rounded text class="my-3" @click="logOut()">
                  <div>
                    <v-icon size="28px">mdi-logout-variant</v-icon>
                  </div>
                  <div class="ml-2 text-capitalize">Cerrar sesión</div>
                </v-btn>
              </div>
            </router-link>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </v-row>
</template>

<script>
import avatarMenuPro from '@/assets/Profesional.svg';
import avatarMenuPat from '@/assets/Paciente.svg';

export default {
  name: 'VAvatarMenu',
  props: ['avatarItems', 'logOut'],
  data() {
    return {};
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
    getAvatarMenuImage(rol) {
      return rol === 'pro' ? avatarMenuPro : avatarMenuPat;
    },
  },
};
</script>
